/* eslint-disable prettier/prettier */
import styled from 'styled-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { X, VideoBackGround } from '../../Constants/assets';

// Stylings

const InnerContainer = styled.div`
    width: 600px;
    height: 320px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 26;
    animation: zoomIn 0.2s ease-in-out;
`;
const TextContainer = styled.div`
    height: 58%;
`;
const Br = styled.div`
    height: 15%;
`;
const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 50%;
    color: ${props => props.theme.colors.black};
    height: 25%;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    line-height: 135%;
    color: ${props => props.theme.colors.black};
    width: 85%;
    display: inline-table;
`;
const ButtonContainer = styled.button`
    width: 40%;
    height: 75%;
    padding: 0px 20px;
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 8px;
    cursor: pointer;
    border: none;
`;
const ButtonContainerLine = styled.div`
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: space-evenly;
`;
const GetStartedButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 2.05vh;
    color: ${props => props.theme.colors.white};
    width: 100%;
`;
// TODO: Fix this, this is temporary fix
export default function ExecuteTaskPopUp({
    show,
    toggleExecutePopUp,
    playerStatus,
    player,
    walkingAlgorithm,
    toggleProject,
    SoundPlay,
    toggleProjectSound,
    toggleIsAnimationNeeded,
    taskScopeState,
}) {
    const { t } = useTranslation();

    if (show) {
        return (
            <InnerContainer>
                <Br />
                <TextContainer>
                    <HeaderText>{t('modals.execute_task.info_title')}</HeaderText>
                    <ParagraphText>
                    {t('modals.execute_task.info_text')}
                    </ParagraphText>
                </TextContainer>
                <ButtonContainerLine>
                    <ButtonContainer
                        onClick={() => {
                            toggleExecutePopUp(false);
                            const taskpopup = !taskScopeState ? toggleProject(0) : null;
                            toggleIsAnimationNeeded(false, true);
                            // SoundPlay(toggleProjectSound);
                        }}
                    >
                        <GetStartedButton>{t('modals.execute_task.button1')}</GetStartedButton>
                    </ButtonContainer>
                </ButtonContainerLine>
            </InnerContainer>
            // old version:
            // <InnerContainer>
            //     <Br />
            //     <TextContainer>
            //         <HeaderText> Execute Another Task</HeaderText>
            //         <ParagraphText>
            //             {' '}
            //             You have completed a task from your project sheet that has advanced you{' '}
            //             {playerStatus.stepsDifference} places on the board. For this task, you paid{' '}
            //             {Math.abs(playerStatus.priceDifference)}$ and used{' '}
            //             {Math.abs(playerStatus.regular)} regular resources,{' '}
            //             {Math.abs(playerStatus.executive)} senior resources and{' '}
            //             {Math.abs(playerStatus.expensive)} executive resources. The value you earned
            //             for your project is {playerStatus.earnedValueDifference}. You have now
            //             reached another planned task so keep playing.
            //         </ParagraphText>
            //     </TextContainer>
            //     <ButtonContainerLine>
            //         <ButtonContainer
            //             onClick={() => {
            //                 toggleExecutePopUp(false);
            //                 const taskpopup = !taskScopeState ? toggleProject(0) : null;
            //                 toggleIsAnimationNeeded(false, true);
            //                 // SoundPlay(toggleProjectSound);
            //             }}
            //         >
            //             <GetStartedButton>Choose Your Next Task</GetStartedButton>
            //         </ButtonContainer>
            //     </ButtonContainerLine>
            // </InnerContainer>
        );
    }
    return null;
}
